/**
 * updates the order gift certificate summary
 * @param {Object} order - the order model
 * @return {Object} $productSummary - gc summary
 */
function updateOrderGiftSummaryInformation(order) {
    const $productSummary = $('<div />');
    order.giftCertificateItems.forEach((gc) => {
        const pliWrapper = $('<div class="card product-card" />');
        const pli = $(`[data-gc-line-item=${gc.lineItem.UUID}]`);
        pliWrapper.append(pli);
        $productSummary.append(pliWrapper);
    });

    return $productSummary.children();
}

/**
 * updates the totals summary
 * @param {Array} totals - the totals data
 */
function updateTotals(totals) {
    if (window.location.href.indexOf('casaviva') > -1) {
        const currentCheckoutStage = $('.data-checkout-stage').attr('data-checkout-stage');
        if (currentCheckoutStage !== 'customer') {
            $('.shipping-total-cost').text(totals.totalShippingCost);
            $('.grand-total-sum').text(totals.grandTotal);

            if (totals.productLevelDiscountTotal > 0) {
                $('.product-discount').removeClass('hide-order-discount');
                $('.product-discount-total').text(`- ${totals.productLevelDiscountTotal.formatted}`);
            } else {
                $('.product-discount').addClass('hide-order-discount');
            }
        }
    } else {
        $('.shipping-total-cost').text(totals.totalShippingCost);
        $('.grand-total-sum').text(totals.grandTotal);
    }

    $('.tax-total').text(totals.totalTax);
    $('.sub-total').text(totals.subTotal);

    if (totals.orderLevelDiscountTotal.value > 0) {
        $('.order-discount').removeClass('hide-order-discount');
        $('.order-discount-total').text(`- ${totals.orderLevelDiscountTotal.formatted}`);
    } else {
        $('.order-discount').addClass('hide-order-discount');
    }

    if (totals.shippingLevelDiscountTotal.value > 0) {
        $('.shipping-discount').removeClass('d-none');
        $('.shipping-discount-total').text(`- ${totals.shippingLevelDiscountTotal.formatted}`);
    } else {
        $('.shipping-discount').addClass('d-none');
    }
}

/**
 * updates the order product shipping summary for an order model
 * @param {Object} order - the order model
 */
function updateOrderProductSummaryInformation(order) {
    const $productSummary = $('<div />');
    order.shipping.forEach((shipping) => {
        shipping.productLineItems.items.forEach((lineItem) => {
            const pliWrapper = $('<div class="card product-card" />');
            const pli = $(`[data-product-line-item=${lineItem.UUID}]`);
            pliWrapper.append(pli);
            $productSummary.append(pliWrapper);
        });

        const address = shipping.shippingAddress || {};
        const selectedMethod = shipping.selectedShippingMethod;

        let nameLine = address.firstName ? `${address.firstName} ` : '';
        if (address.lastName) nameLine += address.lastName;

        const address1Line = address.address1;
        const address2Line = address.address2;

        const phoneLine = address.phone;

        const shippingCost = selectedMethod ? selectedMethod.shippingCost : '';
        const methodNameLine = selectedMethod ? selectedMethod.displayName : '';
        const methodArrivalTime = selectedMethod && selectedMethod.estimatedArrivalTime ? `( ${selectedMethod.estimatedArrivalTime} )` : '';

        const tmpl = $('#pli-shipping-summary-template').clone();

        if (shipping.productLineItems.items && shipping.productLineItems.items.length > 1) {
            $('h5 > span').text(` - ${shipping.productLineItems.items.length} ${order.resources.items}`);
        } else {
            $('h5 > span').text('');
        }

        const stateRequiredAttr = $('#shippingState').attr('required');
        const isRequired = stateRequiredAttr !== undefined && stateRequiredAttr !== false;
        const stateExists = (shipping.shippingAddress && shipping.shippingAddress.stateCode)
            ? shipping.shippingAddress.stateCode
            : false;
        let stateBoolean = false;
        if ((isRequired && stateExists) || (!isRequired)) {
            stateBoolean = true;
        }

        const shippingForm = $(`.multi-shipping input[name="shipmentUUID"][value="${shipping.UUID}"]`).parent();

        if (shipping.shippingAddress
            && shipping.shippingAddress.firstName
            && shipping.shippingAddress.address1
            && shipping.shippingAddress.city
            && stateBoolean
            && shipping.shippingAddress.countryCode
            && (shipping.shippingAddress.phone || shipping.productLineItems.items[0].fromStoreId)) {
            $('.ship-to-name', tmpl).text(nameLine);
            $('.ship-to-address1', tmpl).text(address1Line);
            $('.ship-to-address2', tmpl).text(address2Line);
            $('.ship-to-city', tmpl).text(address.city);
            if (address.stateCode) {
                $('.ship-to-st', tmpl).text(address.stateCode);
            }
            $('.ship-to-zip', tmpl).text(address.postalCode);
            $('.ship-to-phone', tmpl).text(phoneLine);

            if (!address2Line) {
                $('.ship-to-address2', tmpl).hide();
            }

            if (!phoneLine) {
                $('.ship-to-phone', tmpl).hide();
            }

            shippingForm.find('.ship-to-message').text('');
        } else {
            shippingForm.find('.ship-to-message').text(order.resources.addressIncomplete);
        }

        if (shipping.isGift) {
            $('.gift-message-summary', tmpl).text(shipping.giftMessage);
        } else {
            $('.gift-summary', tmpl).addClass('d-none');
        }

        if (shipping.isGift) {
            $('.gift-message-summary', tmpl).text(shipping.giftMessage);
        } else {
            $('.gift-summary', tmpl).addClass('d-none');
        }

        // checking h5 title shipping to or pickup
        const $shippingAddressLabel = $('.shipping-header-text', tmpl);
        $('body').trigger('shipping:updateAddressLabelText', {
            selectedShippingMethod: selectedMethod,
            resources: order.resources,
            shippingAddressLabel: $shippingAddressLabel,
        });

        if (shipping.selectedShippingMethod) {
            $('.display-name', tmpl).text(methodNameLine);
            $('.arrival-time', tmpl).text(methodArrivalTime);
            $('.price', tmpl).text(shippingCost);
        }
    });

    if (order.giftCertificateItems.length > 0) {
        const $gcSummary = updateOrderGiftSummaryInformation(order);
        $productSummary.append($gcSummary);
    }

    $('.product-summary-block').html($productSummary.html());

    // Also update the line item prices, as they might have been altered
    $('.grand-total-price').text(order.totals.subTotal);
    order.items.items.forEach((item) => {
        if (item.priceTotal && item.priceTotal.renderedPrice) {
            $(`.item-total-${item.UUID}`).empty().append(item.priceTotal.renderedPrice);
        }
    });
}

module.exports = {
    updateTotals,
    updateOrderProductSummaryInformation,
};
